/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { useField } from 'formik';
import cx from 'classnames';
import Textarea from 'react-expanding-textarea';
import './TextInput.scss';

const TextInput = ({
  name,
  placeholder,
  variant = 'default',
  disabled,
  label,
  errors,
  touched,
  isTextArea = false,
  isInputWhite,
  formik,
}) => {
  let field = null;

  if (formik) {
    field = formik.getFieldProps(name);
  } else {
    [field] = useField({ name });
  }

  const isError = touched && errors;

  return (
    <div>
      <div
        className={cx({
          'text-input': true,
          [`text-input--${variant}`]: true,
        })}
      >
        {label && field.name && (
          <label className="text-input__label label" htmlFor={field.name}>
            {label}
          </label>
        )}
        {isTextArea ? (
          <Textarea
            type="text"
            name={name}
            placeholder={placeholder}
            className={cx({
              'text-input__input': true,
              'text-input__input--error': isError,
              'text-input__input--white': isInputWhite,
              [`text-input__input--${variant}`]: variant,
            })}
            disabled={disabled}
            {...field}
          />
        ) : (
          <input
            type="text"
            name={name}
            placeholder={placeholder}
            className={cx({
              'text-input__input': true,
              'text-input__input--error': isError,
              'text-input__input--white': isInputWhite,
              [`text-input__input--${variant}`]: variant,
            })}
            disabled={disabled}
            {...field}
          />
        )}
        {placeholder && (
          <span
            className={cx({
              'body-2 body-2--dark-grey-200': true,
              'text-input__placeholder': true,
              'text-input__placeholder--error': isError,
              [`text-input__placeholder--${variant}`]: variant,
            })}
          >
            {placeholder}
          </span>
        )}
        <div className="text-input__border-bottom" />
      </div>
      {isError && <div className="text-input__error">{errors}</div>}
    </div>
  );
};

export default TextInput;
